/* Royalty Hair Extensions — Main JS */

// ---- Header scroll effect ----
(function () {
  const header = document.getElementById('site-header');
  if (!header) return;
  const onScroll = () => {
    header.classList.toggle('scrolled', window.scrollY > 30);
  };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
})();

// ---- Scroll fade-up animations ----
(function () {
  const targets = document.querySelectorAll('.fade-up');
  if (!targets.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) {
        e.target.classList.add('visible');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
  targets.forEach((el, i) => {
    el.style.transitionDelay = (i % 3) * 80 + 'ms';
    io.observe(el);
  });
})();

// ---- Close modal on overlay click ----
document.querySelectorAll('.modal-overlay').forEach((overlay) => {
  overlay.addEventListener('click', (e) => {
    if (e.target === overlay) overlay.classList.remove('open');
  });
});

// ---- Close mobile menu on outside click ----
document.addEventListener('click', (e) => {
  if (!document.body.classList.contains('menu-open')) return;
  if (!e.target.closest('.site-header')) {
    document.body.classList.remove('menu-open');
  }
});

// ---- Smooth scroll for anchor links ----
document.querySelectorAll('a[href^="#"]').forEach((link) => {
  link.addEventListener('click', (e) => {
    const id = link.getAttribute('href').slice(1);
    if (!id) return;
    const target = document.getElementById(id);
    if (target) {
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    }
  });
});

/* ── GDPR CHECKBOX GATE ───────────────────────────────────── */
(function initGdprGate() {
  const avCheck      = document.getElementById('av-check');
  const privacyCheck = document.getElementById('privacy-check');
  const submitBtn    = document.getElementById('reg-submit-btn');

  if (!avCheck || !privacyCheck || !submitBtn) return;

  function updateBtn() {
    const ready = avCheck.checked && privacyCheck.checked;
    submitBtn.disabled    = !ready;
    submitBtn.setAttribute('aria-disabled', String(!ready));
    submitBtn.classList.toggle('btn--gated', !ready);
  }

  avCheck.addEventListener('change', updateBtn);
  privacyCheck.addEventListener('change', updateBtn);
  updateBtn();
})();

/* ── GALLERY ─────────────────────────────────────────────── */
function setGalleryImg(src, alt, btn) {
  const img = document.getElementById('gallery-main-img');
  if (!img) return;
  img.src = src;
  img.alt = alt;
  document.querySelectorAll('.gallery-thumb').forEach((t) => t.classList.remove('active'));
  if (btn) btn.classList.add('active');
}

/* ── QUANTITY ─────────────────────────────────────────────── */
function adjustQty(delta) {
  const input = document.getElementById('qty-input');
  if (!input) return;
  const current = parseInt(input.value, 10) || 1;
  input.value = Math.max(1, current + delta);
}

/* ── VARIANT SELECTOR ─────────────────────────────────────── */
(function initVariants() {
  const product = window.ROYALTY_PRODUCT;
  if (!product) return;

  const selectedOptions = product.variants[0]
    ? [...product.variants[0].options]
    : [];

  function getMatchingVariant() {
    return product.variants.find((v) =>
      v.options.every((o, i) => o === selectedOptions[i])
    );
  }

  function updatePrice(variant) {
    const el = document.getElementById('selected-price');
    if (!el || !variant) return;
    if (variant.price) {
      const formatted = (variant.price / 100).toLocaleString('nl-NL', {
        style: 'currency', currency: 'EUR'
      });
      el.textContent = formatted;
    }
  }

  function updateVariantId(variant) {
    const inp = document.getElementById('variant-id');
    if (inp && variant) inp.value = variant.id;
  }

  function updateAddToCart(variant) {
    const btn = document.getElementById('add-to-cart-btn');
    if (!btn) return;
    if (!variant || !variant.available) {
      btn.textContent = 'Uitverkocht';
      btn.disabled = true;
    } else {
      btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg> In winkelwagen';
      btn.disabled = false;
    }
  }

  window.selectVariantOption = function (btn, optionIndex, value) {
    selectedOptions[optionIndex] = value;

    // Update active state for same group
    btn.closest('.color-swatches, .variant-pills')
      ?.querySelectorAll('.color-swatch, .variant-pill')
      .forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    // Update selected name label for color
    const nameEl = document.getElementById('selected-' + (product.options[optionIndex] || '').toLowerCase());
    if (nameEl) nameEl.textContent = '— ' + value;

    const variant = getMatchingVariant();
    updatePrice(variant);
    updateVariantId(variant);
    updateAddToCart(variant);

    // Update gallery if variant has image
    if (variant && variant.featured_image) {
      const img = document.getElementById('gallery-main-img');
      if (img) {
        img.src = variant.featured_image.src;
        img.alt = variant.featured_image.alt || '';
      }
    }
  };

  // Init
  const variant = getMatchingVariant();
  updateVariantId(variant);
  updateAddToCart(variant);
})();

/* ── MODAL CLOSE FUNCTION ─────────────────────────────────── */
function closeModal() {
  document.querySelectorAll('.modal-overlay').forEach((m) => m.classList.remove('open'));
}

/* ── CATALOG CARDS → smooth scroll to login ──────────────── */
(function initCatalogLinks() {
  document.querySelectorAll('.catalog-card--link').forEach((card) => {
    card.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href && href.startsWith('#')) {
        e.preventDefault();
        const target = document.getElementById(href.slice(1));
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
})();

/* ── WEFT TAB SWITCHER ───────────────────────────────────── */
function switchWeftTab(btn) {
  // Update tab active state
  btn.closest('.weft-tabs').querySelectorAll('.weft-tab').forEach((t) => {
    t.classList.remove('active');
    t.setAttribute('aria-selected', 'false');
  });
  btn.classList.add('active');
  btn.setAttribute('aria-selected', 'true');

  // Swap image
  const img = document.getElementById('weft-img');
  if (img && btn.dataset.img) {
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.3s ease';
    setTimeout(() => {
      img.src = btn.dataset.img;
      img.style.opacity = '1';
    }, 150);
  }

  // Swap text
  const setEl = (id, val) => { const el = document.getElementById(id); if (el && val) el.textContent = val; };
  setEl('weft-tag',   btn.dataset.tag);
  setEl('weft-title', btn.dataset.title);
  setEl('weft-desc',  btn.dataset.desc);
  setEl('weft-specs', btn.dataset.specs);
}

/* ── VAT / BTW VALIDATION ────────────────────────────────── */
(function initVATValidation() {
  // EU VAT number patterns
  const VAT_PATTERNS = {
    NL: /^NL\d{9}B\d{2}$/i,
    BE: /^BE0?\d{9}$/i,
    DE: /^DE\d{9}$/i,
    FR: /^FR[A-Z0-9]{2}\d{9}$/i,
    GB: /^GB(\d{9}|\d{12}|(GD|HA)\d{3})$/i,
    IT: /^IT\d{11}$/i,
    ES: /^ES[A-Z0-9]\d{7}[A-Z0-9]$/i,
    PL: /^PL\d{10}$/i,
    AT: /^ATU\d{8}$/i,
    DK: /^DK\d{8}$/i,
    SE: /^SE\d{12}$/i,
    FI: /^FI\d{8}$/i,
    LU: /^LU\d{8}$/i,
  };

  let debounceTimer;

  window.validateVAT = function(input) {
    clearTimeout(debounceTimer);
    const statusEl = document.getElementById('vat-status');
    const hintEl   = document.getElementById('vat-hint');
    const submitBtn = document.getElementById('reg-submit-btn');
    const val = input.value.trim().toUpperCase().replace(/[\s\.\-]/g, '');

    if (!val || val.length < 5) {
      statusEl.textContent = '';
      statusEl.className = 'vat-status';
      return;
    }

    // Detect country prefix
    const countryCode = val.slice(0, 2);
    const pattern = VAT_PATTERNS[countryCode];

    if (!pattern) {
      statusEl.innerHTML = '✗ Onbekend land';
      statusEl.className = 'vat-status invalid';
      hintEl.textContent = 'Voer een geldig EU BTW-nummer in. Bijv. NL123456789B01';
      return;
    }

    debounceTimer = setTimeout(() => {
      if (pattern.test(val)) {
        statusEl.innerHTML = '✓ Geldig formaat';
        statusEl.className = 'vat-status valid';
        hintEl.textContent = countryCode + '-nummer herkend — aanvraag kan worden ingediend.';
        input.dataset.vatValid = 'true';
      } else {
        statusEl.innerHTML = '✗ Ongeldig formaat';
        statusEl.className = 'vat-status invalid';
        hintEl.textContent = 'Controleer uw BTW-nummer. ' + countryCode + ' formaat verwacht.';
        input.dataset.vatValid = 'false';
      }
    }, 400);
  };
})();
